/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseSdaiApi } from '../../base-api';
export type ExplanationFragment = { __typename: 'ExplanationResponseType', explanationId: string, explanation?: string, summary?: string, status: Types.ExplanationStatus };

export type FileExplanationFragment = { __typename: 'FileExplanationResponseType', explanationId: string, explanation?: string, summary?: string, status: Types.FileExplanationStatus };

export type ChangeDocumentationFragment = { __typename: 'ProjectChangeDocumentationResponseType', explanationId: string, explanation?: string, status: Types.ProjectChangeDocumentationStatus };

export type MessageFragment = { __typename: 'ChatMessageResponseType', message: string, messageId: string, userId: string, chatId: string, creationTimestamp?: any, choices?: Array<{ __typename: 'ChoiceType', question: string, answers: Array<string> }> };

export type ChatFragment = { __typename: 'ChatResponseType', chatId: string, creationTimestamp?: any, creationUserId?: string, history?: Array<{ __typename: 'ChatMessageResponseType', message: string, messageId: string, userId: string, chatId: string, creationTimestamp?: any, choices?: Array<{ __typename: 'ChoiceType', question: string, answers: Array<string> }> }> };

export type ProjectDocumentationFragment = { __typename: 'ProjectDocumentationResponseType', explanationId: string, vendor: string, projectId: string, versionId: string, status: Types.ProjectDocumentationStatus, explanation?: string, summary?: string, language: Types.Language };

export type ProjectAnalysisFragment = { __typename: 'ProjectAnalysisResponseType', analysisId: string, language: Types.Language, vendor: string, s3ProjectTreeBucketKey: string, status: Types.ProjectAnalysisStatus, creationTimestamp?: any };

export type CreateExplanationMutationVariables = Types.Exact<{
  explanation: Types.CreateExplanationInput;
}>;


export type CreateExplanationMutation = { __typename: 'Mutation', createExplanation: { __typename: 'ExplanationResponseType', explanationId: string } };

export type StartChatMutationVariables = Types.Exact<{
  message: Types.StartChatInput;
}>;


export type StartChatMutation = { __typename: 'Mutation', startChat: { __typename: 'ChatResponseType', chatId: string, creationTimestamp?: any, creationUserId?: string, history?: Array<{ __typename: 'ChatMessageResponseType', message: string, messageId: string, userId: string, chatId: string, creationTimestamp?: any, choices?: Array<{ __typename: 'ChoiceType', question: string, answers: Array<string> }> }> } };

export type ContinueChatMutationVariables = Types.Exact<{
  message: Types.ContinueChatInput;
}>;


export type ContinueChatMutation = { __typename: 'Mutation', continueChat: { __typename: 'ChatResponseType', chatId: string, creationTimestamp?: any, creationUserId?: string, history?: Array<{ __typename: 'ChatMessageResponseType', message: string, messageId: string, userId: string, chatId: string, creationTimestamp?: any, choices?: Array<{ __typename: 'ChoiceType', question: string, answers: Array<string> }> }> } };

export type CreateChangeDocumentationMutationVariables = Types.Exact<{
  explanation: Types.CreateProjectChangeDocumentationInput;
}>;


export type CreateChangeDocumentationMutation = { __typename: 'Mutation', createChangeDocumentation: { __typename: 'ProjectChangeDocumentationResponseType', explanationId: string, status: Types.ProjectChangeDocumentationStatus } };

export type CreateFileExplanationMutationVariables = Types.Exact<{
  explanation: Types.CreateFileExplanationInput;
}>;


export type CreateFileExplanationMutation = { __typename: 'Mutation', createFileExplanation: { __typename: 'FileExplanationResponseType', explanationId: string } };

export type CreateFileDifferencesExplanationMutationVariables = Types.Exact<{
  explanation: Types.CreateFileDifferencesExplanationInput;
}>;


export type CreateFileDifferencesExplanationMutation = { __typename: 'Mutation', createFileDifferencesExplanation: { __typename: 'FileExplanationResponseType', explanationId: string } };

export type CreateProjectDocumentationMutationVariables = Types.Exact<{
  documentation: Types.CreateProjectDocumentationInput;
}>;


export type CreateProjectDocumentationMutation = { __typename: 'Mutation', createProjectDocumentation: { __typename: 'ProjectDocumentationResponseType', explanationId: string, vendor: string, projectId: string, versionId: string, status: Types.ProjectDocumentationStatus, explanation?: string, summary?: string, language: Types.Language } };

export type CreateProjectAnalysisMutationVariables = Types.Exact<{
  analysis: Types.CreateProjectAnalysisInput;
}>;


export type CreateProjectAnalysisMutation = { __typename: 'Mutation', createProjectAnalysis: { __typename: 'ProjectAnalysisResponseType', analysisId: string, language: Types.Language, vendor: string, s3ProjectTreeBucketKey: string, status: Types.ProjectAnalysisStatus, creationTimestamp?: any } };

export type CreateProjectAnalysisPresignedUrlMutationVariables = Types.Exact<{
  analysisId: Types.Scalars['String']['input'];
}>;


export type CreateProjectAnalysisPresignedUrlMutation = { __typename: 'Mutation', createProjectAnalysisPresignedUrl?: string };

export type ReadExplanationQueryVariables = Types.Exact<{
  explanationId: Types.Scalars['String']['input'];
}>;


export type ReadExplanationQuery = { __typename: 'Query', readExplanation: { __typename: 'ExplanationResponseType', explanationId: string, explanation?: string, summary?: string, status: Types.ExplanationStatus } };

export type ReadChatQueryVariables = Types.Exact<{
  chatId: Types.Scalars['String']['input'];
}>;


export type ReadChatQuery = { __typename: 'Query', readChat: { __typename: 'ChatResponseType', chatId: string, history?: Array<{ __typename: 'ChatMessageResponseType', creationTimestamp?: any, userId: string, message: string, choices?: Array<{ __typename: 'ChoiceType', question: string, answers: Array<string> }> }> } };

export type ReadAllChatsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadAllChatsQuery = { __typename: 'Query', readAllChats: { __typename: 'PaginatedChatResponseType', items: Array<{ __typename: 'ChatResponseType', chatId: string, creationTimestamp?: any, creationUserId?: string, history?: Array<{ __typename: 'ChatMessageResponseType', message: string, messageId: string, userId: string, chatId: string, creationTimestamp?: any, choices?: Array<{ __typename: 'ChoiceType', question: string, answers: Array<string> }> }> }> } };

export type ReadChangeDocumentationQueryVariables = Types.Exact<{
  explanationId: Types.Scalars['String']['input'];
}>;


export type ReadChangeDocumentationQuery = { __typename: 'Query', readChangeDocumentation: { __typename: 'ProjectChangeDocumentationResponseType', explanationId: string, explanation?: string, status: Types.ProjectChangeDocumentationStatus } };

export type ReadFileExplanationQueryVariables = Types.Exact<{
  explanationId: Types.Scalars['String']['input'];
}>;


export type ReadFileExplanationQuery = { __typename: 'Query', readFileExplanation: { __typename: 'FileExplanationResponseType', explanationId: string, explanation?: string, summary?: string, status: Types.FileExplanationStatus } };

export type ReadProjectDocumentationQueryVariables = Types.Exact<{
  explanationId: Types.Scalars['String']['input'];
}>;


export type ReadProjectDocumentationQuery = { __typename: 'Query', readProjectDocumentation: { __typename: 'ProjectDocumentationResponseType', explanationId: string, vendor: string, projectId: string, versionId: string, status: Types.ProjectDocumentationStatus, explanation?: string, summary?: string, language: Types.Language } };

export type ReadProjectAnalysisQueryVariables = Types.Exact<{
  analysisId: Types.Scalars['String']['input'];
}>;


export type ReadProjectAnalysisQuery = { __typename: 'Query', readProjectAnalysis: { __typename: 'ProjectAnalysisResponseType', analysisId: string, language: Types.Language, vendor: string, s3ProjectTreeBucketKey: string, status: Types.ProjectAnalysisStatus, creationTimestamp?: any } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ExplanationFragmentDoc = new TypedDocumentString(`
    fragment Explanation on ExplanationResponseType {
  __typename
  explanationId
  explanation
  summary
  status
}
    `, {"fragmentName":"Explanation"});
export const FileExplanationFragmentDoc = new TypedDocumentString(`
    fragment FileExplanation on FileExplanationResponseType {
  __typename
  explanationId
  explanation
  summary
  status
}
    `, {"fragmentName":"FileExplanation"});
export const ChangeDocumentationFragmentDoc = new TypedDocumentString(`
    fragment ChangeDocumentation on ProjectChangeDocumentationResponseType {
  __typename
  explanationId
  explanation
  status
}
    `, {"fragmentName":"ChangeDocumentation"});
export const MessageFragmentDoc = new TypedDocumentString(`
    fragment Message on ChatMessageResponseType {
  __typename
  message
  messageId
  userId
  chatId
  creationTimestamp
  choices {
    __typename
    question
    answers
  }
}
    `, {"fragmentName":"Message"});
export const ChatFragmentDoc = new TypedDocumentString(`
    fragment Chat on ChatResponseType {
  __typename
  chatId
  creationTimestamp
  creationUserId
  history {
    __typename
    ...Message
  }
}
    fragment Message on ChatMessageResponseType {
  __typename
  message
  messageId
  userId
  chatId
  creationTimestamp
  choices {
    __typename
    question
    answers
  }
}`, {"fragmentName":"Chat"});
export const ProjectDocumentationFragmentDoc = new TypedDocumentString(`
    fragment ProjectDocumentation on ProjectDocumentationResponseType {
  __typename
  explanationId
  vendor
  projectId
  versionId
  status
  explanation
  summary
  language
}
    `, {"fragmentName":"ProjectDocumentation"});
export const ProjectAnalysisFragmentDoc = new TypedDocumentString(`
    fragment ProjectAnalysis on ProjectAnalysisResponseType {
  __typename
  analysisId
  language
  vendor
  s3ProjectTreeBucketKey
  status
  creationTimestamp
}
    `, {"fragmentName":"ProjectAnalysis"});
export const CreateExplanationDocument = new TypedDocumentString(`
    mutation CreateExplanation($explanation: CreateExplanationInput!) {
  __typename
  createExplanation(explanation: $explanation) {
    __typename
    explanationId
  }
}
    `);
export const StartChatDocument = new TypedDocumentString(`
    mutation StartChat($message: StartChatInput!) {
  __typename
  startChat(message: $message) {
    __typename
    ...Chat
  }
}
    fragment Message on ChatMessageResponseType {
  __typename
  message
  messageId
  userId
  chatId
  creationTimestamp
  choices {
    __typename
    question
    answers
  }
}
fragment Chat on ChatResponseType {
  __typename
  chatId
  creationTimestamp
  creationUserId
  history {
    __typename
    ...Message
  }
}`);
export const ContinueChatDocument = new TypedDocumentString(`
    mutation ContinueChat($message: ContinueChatInput!) {
  __typename
  continueChat(message: $message) {
    __typename
    ...Chat
  }
}
    fragment Message on ChatMessageResponseType {
  __typename
  message
  messageId
  userId
  chatId
  creationTimestamp
  choices {
    __typename
    question
    answers
  }
}
fragment Chat on ChatResponseType {
  __typename
  chatId
  creationTimestamp
  creationUserId
  history {
    __typename
    ...Message
  }
}`);
export const CreateChangeDocumentationDocument = new TypedDocumentString(`
    mutation CreateChangeDocumentation($explanation: CreateProjectChangeDocumentationInput!) {
  __typename
  createChangeDocumentation(explanation: $explanation) {
    __typename
    explanationId
    status
  }
}
    `);
export const CreateFileExplanationDocument = new TypedDocumentString(`
    mutation CreateFileExplanation($explanation: CreateFileExplanationInput!) {
  __typename
  createFileExplanation(explanation: $explanation) {
    __typename
    explanationId
  }
}
    `);
export const CreateFileDifferencesExplanationDocument = new TypedDocumentString(`
    mutation CreateFileDifferencesExplanation($explanation: CreateFileDifferencesExplanationInput!) {
  __typename
  createFileDifferencesExplanation(explanation: $explanation) {
    __typename
    explanationId
  }
}
    `);
export const CreateProjectDocumentationDocument = new TypedDocumentString(`
    mutation CreateProjectDocumentation($documentation: CreateProjectDocumentationInput!) {
  __typename
  createProjectDocumentation(documentation: $documentation) {
    __typename
    ...ProjectDocumentation
  }
}
    fragment ProjectDocumentation on ProjectDocumentationResponseType {
  __typename
  explanationId
  vendor
  projectId
  versionId
  status
  explanation
  summary
  language
}`);
export const CreateProjectAnalysisDocument = new TypedDocumentString(`
    mutation CreateProjectAnalysis($analysis: CreateProjectAnalysisInput!) {
  __typename
  createProjectAnalysis(analysis: $analysis) {
    __typename
    ...ProjectAnalysis
  }
}
    fragment ProjectAnalysis on ProjectAnalysisResponseType {
  __typename
  analysisId
  language
  vendor
  s3ProjectTreeBucketKey
  status
  creationTimestamp
}`);
export const CreateProjectAnalysisPresignedUrlDocument = new TypedDocumentString(`
    mutation CreateProjectAnalysisPresignedUrl($analysisId: String!) {
  __typename
  createProjectAnalysisPresignedUrl(analysisId: $analysisId)
}
    `);
export const ReadExplanationDocument = new TypedDocumentString(`
    query ReadExplanation($explanationId: String!) {
  __typename
  readExplanation(explanationId: $explanationId) {
    __typename
    ...Explanation
  }
}
    fragment Explanation on ExplanationResponseType {
  __typename
  explanationId
  explanation
  summary
  status
}`);
export const ReadChatDocument = new TypedDocumentString(`
    query ReadChat($chatId: String!) {
  __typename
  readChat(chatId: $chatId) {
    __typename
    chatId
    history {
      __typename
      creationTimestamp
      userId
      message
      choices {
        __typename
        question
        answers
      }
    }
  }
}
    `);
export const ReadAllChatsDocument = new TypedDocumentString(`
    query ReadAllChats {
  __typename
  readAllChats {
    __typename
    items {
      __typename
      ...Chat
    }
  }
}
    fragment Message on ChatMessageResponseType {
  __typename
  message
  messageId
  userId
  chatId
  creationTimestamp
  choices {
    __typename
    question
    answers
  }
}
fragment Chat on ChatResponseType {
  __typename
  chatId
  creationTimestamp
  creationUserId
  history {
    __typename
    ...Message
  }
}`);
export const ReadChangeDocumentationDocument = new TypedDocumentString(`
    query ReadChangeDocumentation($explanationId: String!) {
  __typename
  readChangeDocumentation(explanationId: $explanationId) {
    __typename
    ...ChangeDocumentation
  }
}
    fragment ChangeDocumentation on ProjectChangeDocumentationResponseType {
  __typename
  explanationId
  explanation
  status
}`);
export const ReadFileExplanationDocument = new TypedDocumentString(`
    query ReadFileExplanation($explanationId: String!) {
  __typename
  readFileExplanation(explanationId: $explanationId) {
    __typename
    ...FileExplanation
  }
}
    fragment FileExplanation on FileExplanationResponseType {
  __typename
  explanationId
  explanation
  summary
  status
}`);
export const ReadProjectDocumentationDocument = new TypedDocumentString(`
    query ReadProjectDocumentation($explanationId: String!) {
  __typename
  readProjectDocumentation(explanationId: $explanationId) {
    __typename
    ...ProjectDocumentation
  }
}
    fragment ProjectDocumentation on ProjectDocumentationResponseType {
  __typename
  explanationId
  vendor
  projectId
  versionId
  status
  explanation
  summary
  language
}`);
export const ReadProjectAnalysisDocument = new TypedDocumentString(`
    query ReadProjectAnalysis($analysisId: String!) {
  __typename
  readProjectAnalysis(analysisId: $analysisId) {
    __typename
    ...ProjectAnalysis
  }
}
    fragment ProjectAnalysis on ProjectAnalysisResponseType {
  __typename
  analysisId
  language
  vendor
  s3ProjectTreeBucketKey
  status
  creationTimestamp
}`);

const injectedRtkApi = baseSdaiApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    CreateExplanation: build.mutation<Types.CreateExplanationMutation, Types.CreateExplanationMutationVariables>({
      query: (variables) => ({ document: CreateExplanationDocument as unknown as string, variables })
    }),
    StartChat: build.mutation<Types.StartChatMutation, Types.StartChatMutationVariables>({
      query: (variables) => ({ document: StartChatDocument as unknown as string, variables })
    }),
    ContinueChat: build.mutation<Types.ContinueChatMutation, Types.ContinueChatMutationVariables>({
      query: (variables) => ({ document: ContinueChatDocument as unknown as string, variables })
    }),
    CreateChangeDocumentation: build.mutation<Types.CreateChangeDocumentationMutation, Types.CreateChangeDocumentationMutationVariables>({
      query: (variables) => ({ document: CreateChangeDocumentationDocument as unknown as string, variables })
    }),
    CreateFileExplanation: build.mutation<Types.CreateFileExplanationMutation, Types.CreateFileExplanationMutationVariables>({
      query: (variables) => ({ document: CreateFileExplanationDocument as unknown as string, variables })
    }),
    CreateFileDifferencesExplanation: build.mutation<Types.CreateFileDifferencesExplanationMutation, Types.CreateFileDifferencesExplanationMutationVariables>({
      query: (variables) => ({ document: CreateFileDifferencesExplanationDocument as unknown as string, variables })
    }),
    CreateProjectDocumentation: build.mutation<Types.CreateProjectDocumentationMutation, Types.CreateProjectDocumentationMutationVariables>({
      query: (variables) => ({ document: CreateProjectDocumentationDocument as unknown as string, variables })
    }),
    CreateProjectAnalysis: build.mutation<Types.CreateProjectAnalysisMutation, Types.CreateProjectAnalysisMutationVariables>({
      query: (variables) => ({ document: CreateProjectAnalysisDocument as unknown as string, variables })
    }),
    CreateProjectAnalysisPresignedUrl: build.mutation<Types.CreateProjectAnalysisPresignedUrlMutation, Types.CreateProjectAnalysisPresignedUrlMutationVariables>({
      query: (variables) => ({ document: CreateProjectAnalysisPresignedUrlDocument as unknown as string, variables })
    }),
    ReadExplanation: build.query<Types.ReadExplanationQuery, Types.ReadExplanationQueryVariables>({
      query: (variables) => ({ document: ReadExplanationDocument as unknown as string, variables })
    }),
    ReadChat: build.query<Types.ReadChatQuery, Types.ReadChatQueryVariables>({
      query: (variables) => ({ document: ReadChatDocument as unknown as string, variables })
    }),
    ReadAllChats: build.query<Types.ReadAllChatsQuery, Types.ReadAllChatsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllChatsDocument as unknown as string, variables })
    }),
    ReadChangeDocumentation: build.query<Types.ReadChangeDocumentationQuery, Types.ReadChangeDocumentationQueryVariables>({
      query: (variables) => ({ document: ReadChangeDocumentationDocument as unknown as string, variables })
    }),
    ReadFileExplanation: build.query<Types.ReadFileExplanationQuery, Types.ReadFileExplanationQueryVariables>({
      query: (variables) => ({ document: ReadFileExplanationDocument as unknown as string, variables })
    }),
    ReadProjectDocumentation: build.query<Types.ReadProjectDocumentationQuery, Types.ReadProjectDocumentationQueryVariables>({
      query: (variables) => ({ document: ReadProjectDocumentationDocument as unknown as string, variables })
    }),
    ReadProjectAnalysis: build.query<Types.ReadProjectAnalysisQuery, Types.ReadProjectAnalysisQueryVariables>({
      query: (variables) => ({ document: ReadProjectAnalysisDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateExplanationMutation, useStartChatMutation, useContinueChatMutation, useCreateChangeDocumentationMutation, useCreateFileExplanationMutation, useCreateFileDifferencesExplanationMutation, useCreateProjectDocumentationMutation, useCreateProjectAnalysisMutation, useCreateProjectAnalysisPresignedUrlMutation, useReadExplanationQuery, useLazyReadExplanationQuery, useReadChatQuery, useLazyReadChatQuery, useReadAllChatsQuery, useLazyReadAllChatsQuery, useReadChangeDocumentationQuery, useLazyReadChangeDocumentationQuery, useReadFileExplanationQuery, useLazyReadFileExplanationQuery, useReadProjectDocumentationQuery, useLazyReadProjectDocumentationQuery, useReadProjectAnalysisQuery, useLazyReadProjectAnalysisQuery } = injectedRtkApi;

